import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Minus, Plus } from "lucide-react";

const FaqItem = ({ item, open, onToggle }) => (
  <div className="border-b border-white/10">
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      className="flex w-full items-center justify-between gap-6 py-6 text-left group"
    >
      <span
        className={`font-display font-bold text-lg md:text-xl transition-colors duration-300 ${
          open ? "text-white" : "text-white/75 group-hover:text-white"
        }`}
      >
        {item.q}
      </span>
      <span className="flex items-center justify-center w-9 h-9 shrink-0 rounded-full border border-white/12 bg-white/[0.03] group-hover:border-white/25 transition-colors duration-300">
        {open ? (
          <Minus className="w-4 h-4 text-brand-orange" />
        ) : (
          <Plus className="w-4 h-4 text-white/60" />
        )}
      </span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="overflow-hidden"
        >
          <p className="pb-7 pr-14 text-base leading-relaxed text-white/55">
            {item.a}
          </p>
          {item.link && (
            <Link
              to={item.link.to}
              className="group/link -mt-3 mb-7 inline-flex items-center gap-2 text-sm font-bold text-white"
            >
              {item.link.label}
              <ArrowUpRight className="w-4 h-4 group-hover/link:rotate-45 transition-transform duration-300" />
            </Link>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

/** Aufklappbare Fragenliste. Die erste Frage ist anfangs offen. */
export const FaqList = ({ items, initialOpen = 0 }) => {
  const [open, setOpen] = useState(initialOpen);
  return (
    <div className="border-t border-white/10">
      {items.map((item, i) => (
        <FaqItem
          key={item.q}
          item={item}
          open={open === i}
          onToggle={() => setOpen(open === i ? -1 : i)}
        />
      ))}
    </div>
  );
};
